(() => {
  const customerResults = window.customerResults || [];
  const sectionElement = document.querySelector('.before_after_thumbs');
  const resultTitles = sectionElement.querySelectorAll('[data-result-title]');
  const resultDescriptions = sectionElement.querySelectorAll('[data-result-description]');
  
  document.addEventListener('DOMContentLoaded', () => {
    const totalOnLoad = sectionElement.querySelectorAll(
      '.big_swiper_container .swiper-slide:not(.swiper-slide-duplicate)'
    ).length;
    sectionElement.querySelectorAll('[data-swiper-slider]').forEach(el => {
      el.textContent = `1 / ${totalOnLoad}`;
    });

    const swiperBAThumbs = new Swiper('.before_after_thumbs .testimonial_detailed_container .swiper-container', {
      a11y: { slideRole: '' },
      spaceBetween: 10,
      slidesPerView: 'auto',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      centerInsufficientSlides: false,
    });
    new Swiper('.before_after_thumbs .big_swiper_container', {
      a11y: {
        slideRole: 'none',
      },
      navigation: {
        nextEl: '.before_after_thumbs .testimonial_detailed_container [data-next-addon]',
        prevEl: '.before_after_thumbs .testimonial_detailed_container [data-prev-addon]'
      },
      on: {
        slideChange: s => {
          sectionElement.querySelectorAll('[data-swiper-slider]').forEach(el => {
            el.textContent = `${s.realIndex + 1} / ${s.slides.length}`;
          });

          const customer = customerResults[s.realIndex];
          if (customer) {
            resultTitles.forEach(el => { el.textContent = `- ${customer.name} -`; });
            resultDescriptions.forEach(el => { el.textContent = customer.description; });
          }
        }
      },
      thumbs: {
        swiper: swiperBAThumbs,
      }
    });
  });
})();